/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Automix_Fixed_Gain_HelpInputs */

const en_audio_description_export_automix_fixed_gain_help = /** @type {(inputs: Audio_Description_Export_Automix_Fixed_Gain_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fixed Gain: Reduces program audio by a fixed amount during AD events with 250ms fades in/out.`)
};

const fr_audio_description_export_automix_fixed_gain_help = /** @type {(inputs: Audio_Description_Export_Automix_Fixed_Gain_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gain fixe : réduit l'audio du programme d'un niveau fixe pendant les événements d'AD avec des fondus de 250 ms.`)
};

const de_audio_description_export_automix_fixed_gain_help = /** @type {(inputs: Audio_Description_Export_Automix_Fixed_Gain_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feste Verstärkung: Reduziert den Programm-Audiopegel während AD-Ereignissen um einen festen Betrag mit 250 ms Ein-/Ausblendung.`)
};

const it_audio_description_export_automix_fixed_gain_help = /** @type {(inputs: Audio_Description_Export_Automix_Fixed_Gain_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guadagno fisso: riduce l'audio del programma di una quantità fissa durante gli eventi AD con dissolvenze in entrata/uscita di 250 ms.`)
};

const ru_audio_description_export_automix_fixed_gain_help = /** @type {(inputs: Audio_Description_Export_Automix_Fixed_Gain_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фиксированное усиление: уменьшает громкость программного звука на фиксированную величину во время событий AD с затуханием/нарастанием звука в течение 250 мс.`)
};

const es_audio_description_export_automix_fixed_gain_help = /** @type {(inputs: Audio_Description_Export_Automix_Fixed_Gain_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ganancia fija: reduce el audio del programa en una cantidad fija durante eventos AD con fundidos de entrada y salida de 250 ms.`)
};

const zh_cn2_audio_description_export_automix_fixed_gain_help = /** @type {(inputs: Audio_Description_Export_Automix_Fixed_Gain_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`固定增益：在 AD 事件期间，以 250 毫秒淡入/淡出的方式将节目音频降低固定量。`)
};

const ja_audio_description_export_automix_fixed_gain_help = /** @type {(inputs: Audio_Description_Export_Automix_Fixed_Gain_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`固定ゲイン: 250 ミリ秒のフェードイン/フェードアウトで、AD イベント中にプログラムオーディオを一定量削減します。`)
};

const hi_audio_description_export_automix_fixed_gain_help = /** @type {(inputs: Audio_Description_Export_Automix_Fixed_Gain_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फिक्स्ड गेन: विज्ञापन संबंधी घटनाओं के दौरान प्रोग्राम ऑडियो को एक निश्चित मात्रा में कम करता है, जिसमें 250 मिलीसेकंड का फेड इन/आउट होता है।`)
};

const pt_pt2_audio_description_export_automix_fixed_gain_help = /** @type {(inputs: Audio_Description_Export_Automix_Fixed_Gain_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ganho fixo: Reduz o áudio do programa em uma quantidade fixa durante eventos de AD com fades de 250ms.`)
};

/**
* | output |
* | --- |
* | "Fixed Gain: Reduces program audio by a fixed amount during AD events with 250ms fades in/out." |
*
* @param {Audio_Description_Export_Automix_Fixed_Gain_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_automix_fixed_gain_help = /** @type {((inputs?: Audio_Description_Export_Automix_Fixed_Gain_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Automix_Fixed_Gain_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_automix_fixed_gain_help(inputs)
	if (locale === "de") return de_audio_description_export_automix_fixed_gain_help(inputs)
	if (locale === "it") return it_audio_description_export_automix_fixed_gain_help(inputs)
	if (locale === "ru") return ru_audio_description_export_automix_fixed_gain_help(inputs)
	if (locale === "es") return es_audio_description_export_automix_fixed_gain_help(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_automix_fixed_gain_help(inputs)
	if (locale === "ja") return ja_audio_description_export_automix_fixed_gain_help(inputs)
	if (locale === "hi") return hi_audio_description_export_automix_fixed_gain_help(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_automix_fixed_gain_help(inputs)
	return en_audio_description_export_automix_fixed_gain_help(inputs)
});